import { Helmet } from "react-helmet";

const Preload: React.FC = () => {
  return (
    <Helmet>
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700;800;900&display=swap"
        rel="stylesheet"
      />
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap" rel="stylesheet" />
      <link rel="preconnect" href="https://customer-yp8wps06c5vlapon.cloudflarestream.com" />
    </Helmet>
  );
};

export default Preload;
